import { createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-62ac3bd4")
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" No hay datos para mostrar ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Aguarde mientras se cargan las comisiones ")
const _hoisted_3 = ["onClick"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "expanded-row-title" }, "General, Semanal y variación", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "expanded-row-title" }, "General, Semanal y variación", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "expanded-row-title" }, "General, Semanal y variación", -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "País", -1)
const _hoisted_10 = { class: "p-mr-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Cursos", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "p-text-bold" }, "Comienza el", -1)
const _hoisted_13 = {
  key: 0,
  class: "p-p-0 p-mb-2"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-fixed p-p-0" }, " Profesor ", -1)
const _hoisted_15 = { class: "p-col p-p-0" }
const _hoisted_16 = {
  key: 1,
  class: "p-d-flex p-ai-baseline p-col-12 p-p-0"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "p-col-fix p-p-0" }, " Profesor ", -1)
const _hoisted_18 = { class: "p-col p-p-0" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "p-p-0 p-mb-2" }
const _hoisted_22 = { class: "p-d-flex p-ai-baseline p-col-12 p-p-0" }
const _hoisted_23 = { class: "p-col-fixed p-p-0" }
const _hoisted_24 = {
  key: 0,
  class: "p-col p-p-0"
}
const _hoisted_25 = { class: "p-d-flex p-jc-around" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RatingByPersonTable = _resolveComponent("RatingByPersonTable")!
  const _component_PerformanceCell = _resolveComponent("PerformanceCell")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CountrySelector = _resolveComponent("CountrySelector")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ChTag = _resolveComponent("ChTag")!
  const _component_CoursePlanSelector = _resolveComponent("CoursePlanSelector")!
  const _component_CourseTypeSelector = _resolveComponent("CourseTypeSelector")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_CoderBadge = _resolveComponent("CoderBadge")!
  const _component_Tag = _resolveComponent("Tag")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_parentclass = _resolveDirective("parentclass")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    class: "performance-table p-datatable-ssm",
    paginator: true,
    rows: _ctx.recordsPerPage,
    value: _ctx.classSummaryFeedbacksRef,
    dataKey: "courseNumber",
    responsiveLayout: "scroll",
    loading: !_ctx.classSummaryFeedbacksRef,
    filterDisplay: "menu",
    expandedRows: _ctx.expandedRows,
    "onUpdate:expandedRows": _cache[4] || (_cache[4] = ($event: any) => (_ctx.expandedRows = $event)),
    filters: _ctx.filters,
    "onUpdate:filters": [
      _cache[5] || (_cache[5] = ($event: any) => (_ctx.filters = $event)),
      _ctx.updateFilters
    ],
    totalRecords: _ctx.totalRecords,
    lazy: true,
    first: _ctx.firstRecord
  }, _createSlots({
    empty: _withCtx(() => [
      _hoisted_1
    ]),
    loading: _withCtx(() => [
      _hoisted_2
    ]),
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.CourseNumber,
        header: _ctx.allColumns.get(_ctx.ColumnFields.CourseNumber)?.header,
        hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.CourseNumber),
        columnKey: "courseNumber",
        style: _normalizeStyle({ width: _ctx.CoursePerformanceColumnsWidth.CourseNumber }),
        showFilterMatchModes: false,
        filterField: "countries"
      }, {
        body: _withCtx(({ data }) => [
          _withDirectives(_createElementVNode("div", {
            class: "p-d-flex p-ai-center p-jc-around p-p-2",
            onClick: ($event: any) => (!_ctx.isNps && _ctx.toggleExpand(data))
          }, [
            (!_ctx.isNps)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 0,
                  class: _normalizeClass(["pi clickable", _ctx.expandedRowsSet.has(data)
            ? 'pi-chevron-up'
            : 'pi-chevron-down' ]),
                  style: {"font-size":"0.7rem !important"}
                }, null, 2))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              to: {
            name: _ctx.EducationRouteNames.COURSE_DETAIL,
            params: {
              courseId: data.courseNumber
            }
          }
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(data.courseNumber), 1)
              ]),
              _: 2
            }, 1032, ["to"]),
            _createElementVNode("img", {
              src: _ctx.Country.getIconUrlFromCountryCode(data.country),
              alt: data.country
            }, null, 8, _hoisted_8)
          ], 8, _hoisted_7), [
            [_directive_parentclass, [
          _ctx.setBorderBottomCell(data, data.classAverageClassification),
          data.classAverageClassification === _ctx.ClassAverageClassification.Good ? 'bg-good' : 'bg-problem'
        ]]
          ])
        ]),
        filter: _withCtx(({ filterModel }) => [
          _hoisted_9,
          _createVNode(_component_CountrySelector, {
            class: "p-mt-3",
            modelValue: filterModel.value,
            "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
            disabled: _ctx.loading
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
        ]),
        filterclear: _withCtx(({filterCallback}) => [
          _createVNode(_component_Button, {
            type: "button",
            label: "Limpiar",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-text button-underlined"
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["field", "header", "hidden", "style"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.Name,
        header: _ctx.allColumns.get(_ctx.ColumnFields.Name)?.header,
        hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.Name),
        style: _normalizeStyle([{
      width: !_ctx.isNps
        ? _ctx.CoursePerformanceColumnsWidth.CourseName
        : _ctx.CoursePerformanceColumnsWidth.CourseNameFinished
    }]),
        showFilterMatchModes: false,
        filterField: "coursePlans",
        bodyClass: "bg-gray"
      }, {
        body: _withCtx(({ data }) => [
          _withDirectives(_createElementVNode("span", null, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(data.courseName), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.parsedTags, (tag, index) => {
              return (_openBlock(), _createBlock(_component_ChTag, {
                class: _normalizeClass(['p-p-0', { 'p-mr-1': (index + 1) < data.parsedTags.length }]),
                key: tag
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(tag), 1)
                ]),
                _: 2
              }, 1032, ["class"]))
            }), 128))
          ], 512), [
            [_directive_parentclass, [_ctx.setBorderBottomCell(data)]]
          ])
        ]),
        filter: _withCtx(() => [
          _hoisted_11,
          _createVNode(_component_CoursePlanSelector, {
            class: "p-mt-3",
            modelValue: _ctx.filters.coursePlans.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.filters.coursePlans.value = $event)),
            disabled: _ctx.isLoading,
            coursePlans: _ctx.allCoursePlans,
            multipleSelection: true,
            filter: true
          }, null, 8, ["modelValue", "disabled", "coursePlans"]),
          _createVNode(_component_CourseTypeSelector, {
            class: "p-mt-3",
            modelValue: _ctx.filters.courseType.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filters.courseType.value = $event)),
            disabled: _ctx.isLoading
          }, null, 8, ["modelValue", "disabled"])
        ]),
        filterclear: _withCtx(() => [
          _createVNode(_component_Button, {
            class: "p-button-text button-underlined",
            label: "Limpiar",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cleanFilters([_ctx.CoursePerformanceFiltersProps.courseType, _ctx.CoursePerformanceFiltersProps.coursePlans])))
          })
        ]),
        _: 1
      }, 8, ["field", "header", "hidden", "style"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.ClassNumber,
        header: _ctx.allColumns.get(_ctx.ColumnFields.ClassNumber)?.header,
        hidden: _ctx.isNps || !_ctx.filters.columns.value.includes(_ctx.ColumnFields.ClassNumber),
        style: _normalizeStyle({ width: _ctx.CoursePerformanceColumnsWidth.ClassNumber }),
        bodyClass: "bg-gray"
      }, {
        body: _withCtx(({ data: { courseProgress, totalClass } , data }) => [
          _withDirectives(_createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(courseProgress || 0) + "/" + _toDisplayString(totalClass), 1)
          ], 512), [
            [_directive_parentclass, [_ctx.setBorderBottomCell(data)]]
          ])
        ]),
        _: 1
      }, 8, ["field", "header", "hidden", "style"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.Start,
        header: _ctx.allColumns.get(_ctx.ColumnFields.Start)?.header,
        hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.Start),
        style: _normalizeStyle([{
    width: !_ctx.isNps
      ? _ctx.CoursePerformanceColumnsWidth.CourseDate
      : '10%'
  }]),
        showFilterMatchModes: false,
        filterField: "startMonth",
        bodyClass: "bg-gray"
      }, {
        body: _withCtx(({ data: { latinAmericaDates } , data }) => [
          _withDirectives(_createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(latinAmericaDates.start), 1)
          ], 512), [
            [_directive_parentclass, [_ctx.setBorderBottomCell(data)]]
          ])
        ]),
        filter: _withCtx(() => [
          _hoisted_12,
          _createVNode(_component_Calendar, {
            modelValue: _ctx.filters.startMonth.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.filters.startMonth.value = $event)),
            class: "p-mt-3",
            view: "month",
            dateFormat: "MM yy",
            showIcon: true,
            yearRange: "2020:2024",
            placeholder: "Seleccionar",
            showButtonBar: true
          }, null, 8, ["modelValue"])
        ]),
        filterclear: _withCtx(({ filterCallback }) => [
          _createVNode(_component_Button, {
            type: "button",
            label: "Limpiar",
            onClick: ($event: any) => (filterCallback()),
            class: "p-button-text button-underlined"
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["field", "header", "hidden", "style"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.End,
        header: _ctx.allColumns.get(_ctx.ColumnFields.End)?.header,
        hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.End),
        style: _normalizeStyle([{
    width: !_ctx.isNps
      ? _ctx.CoursePerformanceColumnsWidth.CourseDate
      : '10%'
  }]),
        bodyClass: "bg-gray"
      }, {
        body: _withCtx(({ data: { latinAmericaDates } , data }) => [
          _withDirectives(_createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(latinAmericaDates.end), 1)
          ], 512), [
            [_directive_parentclass, [_ctx.setBorderBottomCell(data)]]
          ])
        ]),
        _: 1
      }, 8, ["field", "header", "hidden", "style"]),
      (_ctx.isNps)
        ? (_openBlock(), _createBlock(_component_Column, {
            key: 0,
            field: _ctx.ColumnFields.ComissionGraduated,
            header: _ctx.allColumns.get(_ctx.ColumnFields.ComissionGraduated)?.header,
            hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.ComissionGraduated),
            bodyClass: "bg-gray"
          }, {
            body: _withCtx(({ data: { totalGraduates } }) => [
              _createElementVNode("span", null, _toDisplayString(totalGraduates || 0), 1)
            ]),
            _: 1
          }, 8, ["field", "header", "hidden"]))
        : _createCommentVNode("", true),
      (_ctx.isNps)
        ? (_openBlock(), _createBlock(_component_Column, {
            key: 1,
            field: _ctx.ColumnFields.ComissionTeacher,
            header: _ctx.allColumns.get(_ctx.ColumnFields.ComissionTeacher)?.header,
            hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.ComissionTeacher),
            bodyClass: "bg-gray",
            showFilterMatchModes: false,
            style: _normalizeStyle([{
    width: !_ctx.isNps
      ? _ctx.CoursePerformanceColumnsWidth.CourseDate
      : '20%'
  }])
          }, {
            body: _withCtx(({ data }) => [
              (_ctx.teachers(data.personSummary).length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.teachers(data.personSummary), (teacher) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: teacher._id,
                        class: "p-d-flex p-ai-baseline p-col-12 p-p-0"
                      }, [
                        _hoisted_14,
                        _createElementVNode("div", _hoisted_15, [
                          _createVNode(_component_CoderBadge, {
                            text: teacher.name,
                            backgroundColor: _ctx.CSSColors.GreenBrain,
                            fontSize: "12px",
                            rounded: ""
                          }, null, 8, ["text", "backgroundColor"])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_CoderBadge, {
                        text: "Sin asignar",
                        class: "p-text-center",
                        backgroundColor: _ctx.CSSColors.RedBrain,
                        fontSize: "12px",
                        rounded: ""
                      }, null, 8, ["backgroundColor"])
                    ])
                  ]))
            ]),
            _: 1
          }, 8, ["field", "header", "hidden", "style"]))
        : _createCommentVNode("", true),
      (_ctx.isNps)
        ? (_openBlock(), _createBlock(_component_Column, {
            key: 2,
            field: _ctx.ColumnFields.ComissionCorrectionTF,
            header: _ctx.allColumns.get(_ctx.ColumnFields.ComissionCorrectionTF)?.header,
            hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.ComissionCorrectionTF),
            bodyClass: "bg-gray",
            style: _normalizeStyle([{
    width: !_ctx.isNps
      ? _ctx.CoursePerformanceColumnsWidth.CourseDate
      : '10%'
  }])
          }, {
            body: _withCtx(({ data: { totalDeliveries, totalFinalDeliveries } }) => [
              totalFinalDeliveries
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(totalDeliveries || 0) + "/" + _toDisplayString(totalFinalDeliveries || 0), 1))
                : _createCommentVNode("", true),
              (!totalFinalDeliveries)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "--"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["field", "header", "hidden", "style"]))
        : _createCommentVNode("", true),
      (_ctx.isNps)
        ? (_openBlock(), _createBlock(_component_Column, {
            key: 3,
            field: _ctx.ColumnFields.ComissionLimitDate,
            header: _ctx.allColumns.get(_ctx.ColumnFields.ComissionLimitDate)?.header,
            hidden: !_ctx.filters.columns.value.includes(_ctx.ColumnFields.ComissionLimitDate),
            bodyClass: "bg-gray",
            showFilterMatchModes: false,
            style: _normalizeStyle([{
    width: !_ctx.isNps
      ? _ctx.CoursePerformanceColumnsWidth.CourseDate
      : _ctx.CoursePerformanceColumnsWidth.CourseDateFinished
  }])
          }, {
            body: _withCtx(({ data: { latinAmericaDates } , data }) => [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _withDirectives(_createElementVNode("span", _hoisted_23, [
                    _createTextVNode(_toDisplayString(latinAmericaDates.limitDate), 1)
                  ], 512), [
                    [_directive_parentclass, [_ctx.setBorderBottomCell(data)]]
                  ]),
                  (!_ctx.showTag(latinAmericaDates.limitDate))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _createVNode(_component_CoderBadge, {
                          text: "Demorado",
                          backgroundColor: _ctx.CSSColors.RedBrain,
                          fontSize: "12px",
                          rounded: ""
                        }, null, 8, ["backgroundColor"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            _: 1
          }, 8, ["field", "header", "hidden", "style"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.TeacherSummaryTotal,
        hidden: _ctx.isNps || !_ctx.filters.columns.value.includes(_ctx.ColumnFields.TeacherSummary),
        header: _ctx.allColumns.get(_ctx.ColumnFields.TeacherSummary)?.header,
        sortable: "",
        sortField: "teacherSummaryTotal",
        style: _normalizeStyle({ width: _ctx.CoursePerformanceColumnsWidth.TeacherRating }),
        bodyClass: "bg-gray"
      }, {
        body: _withCtx(({ data }) => [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_PerformanceCell, {
              rating: data.teacherSummaryTotal
            }, null, 8, ["rating"])
          ], 512), [
            [_directive_parentclass, [_ctx.setBorderBottomCell(data)]]
          ])
        ]),
        _: 1
      }, 8, ["field", "hidden", "header", "style"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.TutorSummaryTotal,
        hidden: _ctx.isNps || !_ctx.filters.columns.value.includes(_ctx.ColumnFields.TutorSummary),
        header: _ctx.allColumns.get(_ctx.ColumnFields.TutorSummary)?.header,
        sortable: "",
        sortField: "tutorSummaryTotal",
        style: _normalizeStyle({ width: _ctx.CoursePerformanceColumnsWidth.TutorRating }),
        bodyClass: "bg-gray"
      }, {
        body: _withCtx(({ data }) => [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_PerformanceCell, {
              rating: data.tutorSummaryTotal,
              label: "General del equipo"
            }, null, 8, ["rating"])
          ], 512), [
            [_directive_parentclass, [_ctx.setBorderBottomCell(data)]]
          ])
        ]),
        _: 1
      }, 8, ["field", "hidden", "header", "style"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.ContentSummaryTotal,
        header: _ctx.allColumns.get(_ctx.ColumnFields.ContentSummary)?.header,
        hidden: _ctx.isNps || !_ctx.filters.columns.value.includes(_ctx.ColumnFields.ContentSummary),
        sortable: "",
        sortField: "contentSummaryTotal",
        style: _normalizeStyle({ width: _ctx.CoursePerformanceColumnsWidth.ContentRating}),
        bodyClass: "bg-gray"
      }, {
        body: _withCtx(({ data }) => [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_PerformanceCell, {
              rating: data.contentSummaryTotal
            }, null, 8, ["rating"])
          ], 512), [
            [_directive_parentclass, [_ctx.setBorderBottomCell(data)]]
          ])
        ]),
        _: 1
      }, 8, ["field", "header", "hidden", "style"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.CoordinatorSummaryTotal,
        header: _ctx.allColumns.get(_ctx.ColumnFields.CoordinatorSummary)?.header,
        hidden: _ctx.isNps || !_ctx.filters.columns.value.includes(_ctx.ColumnFields.CoordinatorSummary),
        sortable: "",
        sortField: "coordinatorSummaryTotal",
        style: _normalizeStyle({ width: _ctx.CoursePerformanceColumnsWidth.CoordinatorRating}),
        bodyClass: "bg-gray"
      }, {
        body: _withCtx(({ data }) => [
          _withDirectives(_createElementVNode("div", null, [
            _createVNode(_component_PerformanceCell, {
              rating: data.coordinatorSummaryTotal
            }, null, 8, ["rating"])
          ], 512), [
            [_directive_parentclass, [_ctx.setBorderBottomCell(data)]]
          ])
        ]),
        _: 1
      }, 8, ["field", "header", "hidden", "style"]),
      _createVNode(_component_Column, {
        field: _ctx.ColumnFields.NpsSummary,
        header: _ctx.allColumns.get(_ctx.ColumnFields.NpsSummary)?.header,
        hidden: !_ctx.isNps || !_ctx.filters.columns.value.includes(_ctx.ColumnFields.NpsSummary),
        style: _normalizeStyle([{ width: _ctx.CoursePerformanceColumnsWidth.NPSRating }]),
        sortable: "",
        sortField: "npsSummary.rating.value",
        bodyClass: "bg-gray"
      }, {
        body: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_25, [
            _createVNode(_component_Tag, {
              class: _normalizeClass(data.npsSummary
        &&
        (data.npsSummary.rating.value > 0 && data.npsSummary.rating.value < 7
        ? 'p-tag-red-brain'
        : data.npsSummary.rating.value >= 7 && data.npsSummary.rating.value < 9
        ? 'p-tag-yellow-brain' : 'p-tag-light-green-brain')
        )
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(data.npsSummary?.nps ? data.npsSummary.nps : '-'), 1)
              ]),
              _: 2
            }, 1032, ["class"])
          ])
        ]),
        _: 1
      }, 8, ["field", "header", "hidden", "style"])
    ]),
    _: 2
  }, [
    (!_ctx.isNps)
      ? {
          name: "expansion",
          fn: _withCtx(({ data: expandedData }) => [
            _createElementVNode("table", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  style: _normalizeStyle({ width: _ctx.CoursePerformanceColumnsWidth.CourseNumber }),
                  class: _normalizeClass({'bg-good': expandedData.classAverageClassification === _ctx.ClassAverageClassification.Good, 'bg-problem': expandedData.classAverageClassification === _ctx.ClassAverageClassification.Bad }),
                  onClick: ($event: any) => (_ctx.toggleExpand(expandedData))
                }, null, 14, _hoisted_3),
                (_ctx.filters.columns.value.includes(_ctx.ColumnFields.Name))
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 0,
                      style: _normalizeStyle({ width: _ctx.CoursePerformanceColumnsWidth.CourseName })
                    }, null, 4))
                  : _createCommentVNode("", true),
                (_ctx.filters.columns.value.includes(_ctx.ColumnFields.ClassNumber))
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 1,
                      style: _normalizeStyle({ width: _ctx.CoursePerformanceColumnsWidth.ClassNumber })
                    }, null, 4))
                  : _createCommentVNode("", true),
                (_ctx.filters.columns.value.includes(_ctx.ColumnFields.Start))
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 2,
                      style: _normalizeStyle({ width: _ctx.CoursePerformanceColumnsWidth.CourseDate })
                    }, null, 4))
                  : _createCommentVNode("", true),
                (_ctx.filters.columns.value.includes(_ctx.ColumnFields.End))
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 3,
                      style: _normalizeStyle({ width: _ctx.CoursePerformanceColumnsWidth.CourseDate })
                    }, null, 4))
                  : _createCommentVNode("", true),
                (_ctx.filters.columns.value.includes(_ctx.ColumnFields.TeacherSummary))
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 4,
                      style: _normalizeStyle([{ width: _ctx.CoursePerformanceColumnsWidth.TeacherRating }, {"padding":"0.2em !important"}])
                    }, [
                      _hoisted_4,
                      _createVNode(_component_RatingByPersonTable, {
                        persons: expandedData.getStaffSummariesByRole(_ctx.PersonRoles.Teacher).sort(_ctx.FeedbackSummary.sortByPersonRating),
                        personSummaryTotal: expandedData.personSummaryTotal
                      }, null, 8, ["persons", "personSummaryTotal"])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.filters.columns.value.includes(_ctx.ColumnFields.TutorSummary))
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 5,
                      style: _normalizeStyle([{ width: _ctx.CoursePerformanceColumnsWidth.TutorRating }, {"padding":"0.2em !important"}])
                    }, [
                      _hoisted_5,
                      _createVNode(_component_RatingByPersonTable, {
                        persons: expandedData.getStaffSummariesByRole(_ctx.PersonRoles.Tutor).sort(_ctx.FeedbackSummary.sortByPersonRating),
                        personSummaryTotal: expandedData.personSummaryTotal
                      }, null, 8, ["persons", "personSummaryTotal"])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.filters.columns.value.includes(_ctx.ColumnFields.ContentSummary))
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 6,
                      style: _normalizeStyle({ width: _ctx.CoursePerformanceColumnsWidth.ContentRating, fontSize: '0.75rem' })
                    }, [
                      _createVNode(_component_PerformanceCell, {
                        rating: expandedData.contentSummary.rating.value,
                        change: expandedData.contentSummary.rating.variation,
                        label: "Semanal y variación",
                        labelClass: "expanded-row-title",
                        hiddenChange: false
                      }, null, 8, ["rating", "change"])
                    ], 4))
                  : _createCommentVNode("", true),
                (_ctx.filters.columns.value.includes(_ctx.ColumnFields.CoordinatorSummary))
                  ? (_openBlock(), _createElementBlock("td", {
                      key: 7,
                      style: _normalizeStyle({ width: _ctx.CoursePerformanceColumnsWidth.CoordinatorRating })
                    }, [
                      _hoisted_6,
                      _createVNode(_component_RatingByPersonTable, {
                        persons: expandedData.getStaffSummariesByRole(_ctx.PersonRoles.Coordinator).sort(_ctx.FeedbackSummary.sortByPersonRating),
                        personSummaryTotal: expandedData.personSummaryTotal
                      }, null, 8, ["persons", "personSummaryTotal"])
                    ], 4))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        }
      : undefined
  ]), 1032, ["rows", "value", "loading", "expandedRows", "filters", "totalRecords", "first", "onUpdate:filters"]))
}